export default __webpack_public_path__ + "static/media/Talent_Guerrilla.d177d4dc.png";